import apiClient from './api';
import type {
  PayMongoAttachSavedBody,
  PayMongoAttachSavedResponse,
  PayMongoConfirmRequest,
  PayMongoCreateIntentRequest,
  PayMongoIntentResponse,
} from '../types/billing';
import type { MePatchResponse } from '../types/auth';

class BillingService {
  async createPayMongoPaymentIntent(body: PayMongoCreateIntentRequest): Promise<PayMongoIntentResponse> {
    const response = await apiClient.post<PayMongoIntentResponse>('/billing/paymongo/create-payment-intent', body);
    return response.data;
  }

  async attachPayMongoSavedPaymentMethod(body: PayMongoAttachSavedBody): Promise<PayMongoAttachSavedResponse> {
    const response = await apiClient.post<PayMongoAttachSavedResponse>(
      '/billing/paymongo/attach-saved-payment-method',
      body,
    );
    return response.data;
  }

  async confirmPayMongoSubscription(body: PayMongoConfirmRequest): Promise<MePatchResponse> {
    const response = await apiClient.post<MePatchResponse>('/billing/paymongo/confirm-subscription', body);
    return response.data;
  }
}

export default new BillingService();
